import Button from "@Components/Button";
import styles from "./TermsAndConditionDesktop.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import { useState } from "react";
import useTranslationHook from "hooks/useTranslationHook";

const TermsAndConditionDesktop = () => {
  const { t } = useTranslationHook();
  const [showMoreTerms, setShowMoreTerms] = useState(false);
  const toggleTermsAndConditions = () => {
    setShowMoreTerms(!showMoreTerms);
  };
  return (
    <section className={styles.termsAndConditionsContainer}>
      <div>
        <h2 className={styles.termsAndConditionsHeading}>{t("referral.terms.title")}</h2>
        <ul className={styles.termsAndConditionsList}>
          <li>{t("referral.terms.item1")}</li>
          <li>{t("referral.terms.item2")}</li>
          <div style={{ display: "flex" }}>
            <li>
              {t("referral.terms.item3.before")}
              {t("referral.terms.item3.after")}
            </li>
            {!showMoreTerms && (
              <Button
                variant="showMore"
                onClick={toggleTermsAndConditions}
                className={styles.seeMoreCTA}
              >
                {t("referral.terms.seemore")}
              </Button>
            )}
          </div>
          {showMoreTerms && (
            <>
              <li>{t("referral.terms.item4")}</li>
              <li>{t("referral.terms.item5")}</li>
              <li>{t("referral.terms.item6")}</li>
              <li>{t("referral.terms.item7")}</li>
              <li>{t("referral.terms.item8")}</li>
              <li>{t("referral.terms.item9")}</li>
              <li>
                {t("referral.terms.item10.before")}
                {t("referral.terms.item10.after")}
              </li>
              <li>{t("referral.terms.item11")}</li>
              <li className={styles.termsNote}>{t("referral.terms.note")}</li>
              <Button
                variant="showLess"
                onClick={toggleTermsAndConditions}
                className={styles.seeLessCTA}
              >
                {t("referral.terms.seeless")}
              </Button>
            </>
          )}
        </ul>
      </div>
    </section>
  );
};

export default wrapperHOC(TermsAndConditionDesktop, {
  componentName: "TermsAndConditionDesktop-ReferralDesktop",
  showForChina: true,
});
